import React from 'react';
import { Box, Checkbox, Text, InputLabel as Label, Spacer, theme } from '../..';
import { CheckboxFieldProps } from './CheckboxFieldProps';

const CheckboxField = ({
  disabled,
  dmId = 'dm-checkbox-field',
  id,
  error,
  invalid,
  label,
  onChange,
  required,
  styles = {},
  value,
  checked = false,
  ...otherProps
}: CheckboxFieldProps): JSX.Element => {
  const uniqueCheckboxId = `${id || dmId}-input`;
  const errorId = `${id || dmId}-input-error`;
  return (
    <Box data-designsystem>
      <Box style={{ alignItems: 'center', flexDirection: 'row' }}>
        <Checkbox
          disabled={disabled}
          dmId={`${dmId}-input`}
          id={uniqueCheckboxId}
          invalid={invalid}
          onChange={onChange}
          style={styles && styles.checkbox}
          value={value}
          checked={checked}
          aria-describedby={error && invalid ? errorId : undefined}
          {...otherProps}
        />

        <Spacer size={`${theme.dimension.spacing.xxxs.value}rem`} />

        <Label
          disabled={disabled}
          dmId={`${dmId}-label`}
          id={`${id}-label`}
          htmlFor={uniqueCheckboxId}
          required={required}
          style={styles && styles.label}>
          {label}
        </Label>
      </Box>

      {error && invalid && (
        <>
          <Spacer size={`${theme.dimension.spacing.xxxs.value}rem`} />
          <Text
            dmId={`${dmId}-error-text`}
            id={errorId}
            kind="error"
            style={styles && styles.error}>
            {error.length > 0 ? error : ''}
          </Text>
        </>
      )}

      <Spacer size={`${theme.dimension.spacing.xs.value}rem`} />
    </Box>
  );
};

export default CheckboxField;
